import { render, staticRenderFns } from "./ContactNoticeList.vue?vue&type=template&id=5a5d5f81&"
import script from "./ContactNoticeList.vue?vue&type=script&lang=ts&"
export * from "./ContactNoticeList.vue?vue&type=script&lang=ts&"
import style0 from "./ContactNoticeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VDataTable,VRow,VSpacer})
